/*
 * This file is part of the https://gitlab-intern.easd-support.de/easd/p26s26_energie_watchdog project.
 *
 * (c) 2026 EA Systems Dresden GmbH
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

export function createTimestampedFilename(prefix: string, extension: string): string {
    const timestamp = new Date()
        .toISOString()
        .replace('T', '_')
        .replace(/[:.]/g, '-')
        .replace('Z', '');

    return `${prefix}-${timestamp}.${extension}`;
}

export function downloadBlob(blob: Blob, filename: string): void {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');

    link.download = filename;
    link.href = url;
    document.body.append(link);
    link.click();

    // Keep both resources alive until the browser has started the download.
    window.setTimeout(() => {
        link.remove();
        URL.revokeObjectURL(url);
    }, 1_000);
}

export function downloadTextFile(content: string, filename: string, mimeType: string): void {
    downloadBlob(new Blob([content], { type: `${mimeType};charset=utf-8` }), filename);
}
